import React, { useState, useContext, useEffect, useRef } from "react";
import mondrian from "core/config/theme";
import HeaderMenu from "components/HeaderMenu/HeaderMenu";
import Loading from "components/Loading";
import styled from "styled-components";
import Cookies from "universal-cookie";
import { getDomainName } from "core/Utils";
import { useTheme } from "mondrian-react";
import { loadDynamicScripts } from "core/Utils/Utils";
import { store } from "store.js";
import messages from "../../components/messages.json";
import endSession from "core/api/endSession/endSession";
import InternalLink from "components/InternalLink";
import { setResetPasswordUrlRedirect } from "core/Utils/SetResetPasswordUrl";

const cookies = new Cookies();
export const Container = styled.div`
  margin-bottom: ${mondrian.spacingStackMd};
`;

export default function Header({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { contrast, user } = state;
  const logoutLink = process.env.REACT_APP_END_SESSION_REDIRECT ;
  const profileMenuRef = useRef();

  useState(window.MondrianReact.useTab);

  const logoutFn = async function(ev) {
    setIsLoading(true);
    await endSession();
    
    ev.preventDefault();
    cookies.remove("accesstoken", {
      domain: getDomainName(window.location.hostname),
    });
      document.location.href = logoutLink ;
  };
  const [mobileActive, setMobileActive] = useState(false);
  const [contraste, setContraste] = useState(false);
  const { toggleTheme } = useTheme();

  function handleBlur(e) {
    if (e && e.relatedTarget) {
      e.relatedTarget.click();
    }
    setMobileActive(false);
  }
  function handleContrasteClick() {
    setContraste((current) => !current);
    toggleTheme();
  }
  useEffect(
    function () {
      let auxContraste = contrast === undefined ? false : contraste;
      dispatch({
        type: "SET_CONTRASTE",
        payload: !auxContraste,
      });
    },
    [contrast, contraste, dispatch]
  );

  const [pluginIsLoaded, LoadPlugin] = useState(false);
  //if (disableRuleContent()) return null;
  function loadHandTalk(cb) {
    loadDynamicScripts
      .url("https://plugin.handtalk.me/web/latest/handtalk.min.js")
      .then(function () {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "handTalk";
        // eslint-disable-next-line
        var ht = new HT({
          token: `${process.env.REACT_APP_HANDTALK_TOKEN}`,
          clickables: [".mdn-Icon-fechar"],
        });
        document.body.appendChild(script);
      });
  }

  function handleLibrasClick() {
    if (pluginIsLoaded) return;
    LoadPlugin(true);
    loadHandTalk();
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <Container className="cred-header">
        <header className="mdn-Menu" role="banner">
          <div id="mdn-SkipLink" className="mdn-SkipLink skip-link">
            <div className="mdn-Container">
              <ul className="mdn-SkipLink-list">
                <li className="mdn-SkipLink-list--item">
                  <a
                    className="mdn-Link mdn-Link--default mdn-Link gtm-element-event mdn-SkipLink-TextBody"
                    title="Atalhos de acessibilidade: ir-para-conteudo"
                    target="_self"
                    tabIndex="1"
                    href="#mdn-MainContent"
                  >
                    {messages.acessibility.MainContent.text}
                  </a>
                </li>
                <li className="mdn-SkipLink-list--item">
                  <a
                    className="mdn-Link mdn-Link--default mdn-Link gtm-element-event mdn-SkipLink-TextHeader"
                    title="Atalhos de acessibilidade: ir-para-cabecalho"
                    target="_self"
                    tabIndex="2"
                    href="#mdn-Header"
                  >
                    {messages.acessibility.Header.text}
                  </a>
                </li>
                <li className="mdn-SkipLink-list--item">
                  <a
                    className="mdn-Link mdn-Link--default mdn-Link gtm-element-event mdn-SkipLink-TextFooter"
                    title="Atalhos de acessibilidade: ir-para-rodape"
                    target="_self"
                    tabIndex="3"
                    href="#mdn-Footer"
                  >
                    {messages.acessibility.Footer.text}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mdn-Menu-top">
            <div className="mdn-Container">
              <nav className="mdn-Menu-top-content">
                <ul className="mdn-Menu-top-list mdn-Menu-top-list-left"></ul>
                <ul className="mdn-Menu-top-list mdn-Menu-top-list-right">
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                    <i className="mdn-Icon-pcd mdn-Icon--sm"></i>
                    <a
                      href="https://www.claro.com.br/institucional/regulatorio/acessibilidade"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mdn-Text mdn-Menu-top-action"
                      tabIndex="4"
                    >
                      Acessibilidade
                    </a>
                  </li>
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                    <i className="mdn-Icon-alto-contraste mdn-Icon--sm"></i>
                    <button
                      className="mdn-Text mdn-Menu-top-action"
                      onClick={handleContrasteClick}
                      tabIndex="5"
                    >
                      Contraste
                    </button>
                  </li>
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                    <button
                      className="mdn-Text mdn-Menu-top-action btn-handTalk"
                      onClick={handleLibrasClick}
                      tabIndex="6"
                    >
                      <i className="mdn-Icon-libras mdn-Icon--md"></i>
                    </button>
                  </li>
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                    <div
                      className=" mdn-Link--arrow mdn-Modal--handler"
                      data-mdn-modal-id="modal-tamanho"
                    >
                      <button
                        className="mdn-Text mdn-Menu-top-action"
                        tabIndex="7"
                      >
                        <i className="mdn-Icon-diminuir-tamanho mdn-Icon--sm"></i>
                        <i className="mdn-Icon-aumentar-tamanho mdn-Icon--sm"></i>
                      </button>
                    </div>
                  </li>
                </ul>

                <div id="modal-tamanho" className="mdn-Modal mdn-Modal--sm">
                  <div className="mdn-Modal-content">
                    <div className="mdn-Modal-body">
                      <div className="mdn-Text mdn-Text--body">
                        <div>
                          Para aumentar ou reduzir a fonte, utilize os atalhos
                          nativos do seu navegador:
                          <br />
                          <ul>
                            <li>
                              <span
                                className="mdn-Icon-verificado mdn-Icon--sm"
                                aria-hidden="true"
                              ></span>
                              No windows&nbsp;<strong>CTRL</strong>
                              +&nbsp;(para aumentar) e&nbsp;
                              <strong>CTRL</strong> -&nbsp;(para diminuir)
                            </li>
                            <li>
                              <span
                                className="mdn-Icon-verificado mdn-Icon--sm"
                                aria-hidden="true"
                              ></span>
                              No macOS (safari)&nbsp;<strong>CMD</strong>
                              +&nbsp;(para aumentar) e&nbsp;<strong>CMD</strong>
                              -&nbsp;(para diminuir)
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="mdn-Modal-footer">
                      <div className="mdn-Modal-footer-end">
                        <button className="mdn-Button mdn-Button--primary  mdn-Button-close">
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="mdn-Menu-container mdn-Container">
            <nav className="mdn-Menu-content">
              <div className="mdn-Menu-content-left">
                <button
                  className="mdn-Menu-toggle"
                  onClick={() => setMobileActive(!mobileActive)}
                  onBlur={handleBlur}
                >
                  <i className="mdn-Icon-menu mdn-Icon--md mdn-Menu-toggle-icon mdn-Menu-toggle-icon-menu"></i>
                  <i className="mdn-Icon-fechar mdn-Icon--md mdn-Menu-toggle-icon mdn-Menu-toggle-icon-fechar"></i>
                </button>
                <img
                  className="mdn-Menu-logo"
                  src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg"
                  alt="Logo da Claro"
                />
                <ul
                  className={
                    mobileActive
                      ? "mdn-Menu-list mdn-isActive cred-mobile-open"
                      : "mdn-Menu-list mdn-isActive cred-mobile-closed"
                  }
                >
                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <div className="mdn-Menu-subMenu-back">
                        <i className="mdn-Icon-esquerda mdn-Icon--md"></i>
                      </div>
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <InternalLink
                          className="cred-card"
                          link="/meuperfil"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:link"
                          data-gtm-event-label="meu-perfil"
                        >
                          <span
                            className="mdn-Icon-minha-claro mdn-Icon--md mdn-u-marginRight--xxs "
                            aria-hidden="true"
                          ></span>
                          Meu Perfil
                        </InternalLink>
                      </button>
                    </div>
                  </li>
                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <div className="mdn-Menu-subMenu-back">
                        <i className="mdn-Icon-esquerda mdn-Icon--md"></i>
                      </div>
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <InternalLink
                          className="cred-card"
                          link="/meuperfil/alterar-email"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="alterar-email"
                        >
                          <span
                            className="mdn-Icon-e-mail mdn-Icon--md mdn-u-marginRight--xxs"
                            aria-hidden="true"
                          ></span>
                          Alterar E-mail
                        </InternalLink>
                      </button>
                    </div>
                  </li>
                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <div className="mdn-Menu-subMenu-back">
                        <i className="mdn-Icon-esquerda mdn-Icon--md"></i>
                      </div>
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <InternalLink
                          className="cred-card"
                          link="#"
                          onClick={() => {
                            setIsLoading(true);
                            setResetPasswordUrlRedirect(user);
                            setTimeout(() => setIsLoading(false), 1000);
                          }}
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="alterar-senha"
                        >
                          <span
                            className="mdn-Icon-senha mdn-Icon--md mdn-u-marginRight--xxs"
                            aria-hidden="true"
                          ></span>
                          Alterar Senha
                        </InternalLink>
                      </button>
                    </div>
                  </li>
                  {/* <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <div className="mdn-Menu-subMenu-back">
                        <i className="mdn-Icon-esquerda mdn-Icon--md"></i>
                      </div>
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <InternalLink
                          className="cred-card"
                          link="/meuperfil/meus-numeros"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="meus-numeros"
                        >
                          <span
                            className="mdn-Icon-solar-ache-aqui mdn-Icon--md mdn-u-marginRight--xxs"
                            aria-hidden="true"
                          ></span>
                          Meus Números
                        </InternalLink>
                      </button>
                    </div>
                  </li> */}
                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <div className="mdn-Menu-subMenu-back">
                        <i className="mdn-Icon-esquerda mdn-Icon--md"></i>
                      </div>
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <InternalLink
                          className="cred-card"
                          link="/meuperfil/acesso-pelo-celular"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="acesso-pelo-celular"
                        >
                          <span
                            className="mdn-Icon-solar-ache-aqui mdn-Icon--md mdn-u-marginRight--xxs"
                            aria-hidden="true"
                          ></span>
                          Acesso pelo celular
                        </InternalLink>
                      </button>
                    </div>
                  </li>
                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <span
                          className="mdn-Icon-celular mdn-Icon--md mdn-u-marginRight--xxs"
                          aria-hidden="true"
                        ></span>
                        <a
                          className="cred-card"
                          href="https://minhaclaro.claro.com.br/"
                          target="_blank"
                          rel="noopener noreferrer"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="minha-claro-movel"
                        >
                          Minha Claro Móvel
                        </a>
                      </button>
                    </div>
                  </li>

                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <span
                          className="mdn-Icon-residencial mdn-Icon--md mdn-u-marginRight--xxs"
                          aria-hidden="true"
                        ></span>
                        <a
                          className="cred-card"
                          href="https://auth.claro.com.br/authorize?client_id=MINHA_CLARO_RESIDENCIAL&redirect_uri=https%3A%2F%2Fminhaclaroresidencial.claro.com.br%2Flogin&response_type=code&scope=openid+minha_net+net_profile&authMs=UP%2CEP%2CDOCP%2COTP"
                          target="_blank"
                          rel="noopener noreferrer"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="minha-claro-residencial"
                        >
                          Minha Claro Residencial
                        </a>
                      </button>
                    </div>
                  </li>

                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <button className="mdn-Text mdn-Menu-list-anchor">
                        <span
                          className="mdn-Icon-tv mdn-Icon--md mdn-u-marginRight--xxs"
                          aria-hidden="true"
                        ></span>
                        <a
                          className="cred-card"
                          href="https://www.clarotvmais.com.br/home-landing"
                          target="_blank"
                          rel="noopener noreferrer"
                          data-gtm-event-category="minha-claro:meu-perfil"
                          data-gtm-event-action="clique:menu-header"
                          data-gtm-event-label="minha-claro-tv"
                        >
                          Minha Claro TV (Claro TV+)
                        </a>
                      </button>
                    </div>
                  </li>

                  <li className="mdn-Menu-list-item">
                    <div className="mdn-Menu-list-item-link">
                      <button className="mdn-Text mdn-Menu-list-anchor" 
                      onClick={logoutFn}    
                      data-gtm-event-category="minha-claro:meu-perfil"
                      data-gtm-event-action="clique:menu-header"
                      data-gtm-event-label="sair">
                        <span
                          className="mdn-Icon-sair mdn-Icon--md mdn-u-marginRight--xxs"
                          aria-hidden="true"
                        ></span>
                      
                          Sair
                    
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mdn-Menu-content-right">
                <HeaderMenu ref={profileMenuRef} globalState={globalState} />
              </div>
            </nav>
          </div>
        </header>
        {children}
      </Container>
    </>
  );
}
